/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import classNames from 'classnames';
import { forwardRef, type CSSProperties, type ForwardedRef } from 'react';
import styles from './LayoutStack.module.css';
import { CommonLayoutStackProps, LayoutStackProps } from './types';
const LayoutStack = forwardRef(function LayoutStack({
  as: Tag = 'div',
  className,
  style,
  space = '200',
  container,
  flex,
  ...props
}: LayoutStackProps, ref: ForwardedRef<HTMLElement>) {
  return <Tag ref={ref as any} {...props as Extract<typeof props, CommonLayoutStackProps>} className={classNames(styles.stack, {
    [styles.container!]: container,
    [styles.flex!]: flex
  }, className)} style={{
    ...style,
    '--space': `var(--betterplace-spacing-${space})`
  } as CSSProperties}>
      {props.children}
    </Tag>;
});
export default LayoutStack;